import { useTranslation } from "react-i18next"
import { TableInstance } from "@tanstack/react-table"
import { Icon } from "../Icon"
import { PaginationMeta } from "../../types/PaginationMeta"

interface Props<T, D> {
  instance: TableInstance<T>
  data: Array<D>
  paginationMeta?: PaginationMeta
}

export function ReferralTableFooter<T, D>({
  instance,
  data,
  paginationMeta,
}: Props<T, D>) {
  const instanceState = instance.getState()
  const { t } = useTranslation()

  return (
    <div className="flex items-center justify-between mt-6 rounded-lg p-6 border border-[color:var(--alias-color-border-base)]]">
      <span className="flex items-center gap-1">
        {t("admin.pagination.showResults", {
          start: Math.min(
            instanceState.pagination.pageIndex *
              instanceState.pagination.pageSize +
              1,
            paginationMeta?.total_items ?? data.length,
          ),
          end: Math.min(
            (instanceState.pagination.pageIndex + 1) *
              instanceState.pagination.pageSize,
            paginationMeta?.total_items ?? data.length,
          ),
          total:
            paginationMeta?.total_items ??
            Math.min(
              instance.getPageCount() * instanceState.pagination.pageSize,
              data.length,
            ),
        })}
      </span>
      <div className="flex items-center">
        <button
          className="border-none rounded p-1 mr-6 flex items-center justify-center disabled:opacity-50"
          onClick={() => instance.previousPage()}
          disabled={!instance.getCanPreviousPage()}
        >
          <Icon variant="ChevronLeft" size="sm" className="mr-2" />
          {t("admin.buttons.back")}
        </button>
        {instance.getCanPreviousPage() ? (
          <button
            className="h-6 w-6 flex items-center justify-center mr-2"
            onClick={() => instance.previousPage()}
          >
            {instanceState.pagination.pageIndex}
          </button>
        ) : null}
        <button className="h-6 w-6 bg-[color:var(--alias-color-border-weak)] flex items-center justify-center mr-2">
          {instanceState.pagination.pageIndex + 1}
        </button>
        {instance.getCanNextPage() ? (
          <button
            className="h-6 w-6 flex items-center justify-center mr-2"
            onClick={() => instance.nextPage()}
          >
            {instanceState.pagination.pageIndex + 2}
          </button>
        ) : null}
        <button
          className="border-none rounded p-1 ml-4 flex items-center justify-center disabled:opacity-50"
          onClick={() => instance.nextPage()}
          disabled={!instance.getCanNextPage()}
        >
          {t("admin.buttons.next")}
          <Icon variant="ChevronRight" size="sm" className="ml-2" />
        </button>
      </div>
    </div>
  )
}
